import React from "react";
import MainPagePresenter from "./MainPagePresenter";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route, useLocation } from "react-router-dom";
import { OffCanvas } from "../../nq-component";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "../../nq-component";
import MigrationPage from "../migration/MigrationPage";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import DashboardPage from "../dashboard/DashboardPage";
import HooksPage from "../web-hook/HooksPage";
import FunctionPage from "../web-hook/FunctionPage";
import SchemaPage from "../schema/SchemaPage";
import SetupPage from "../setup/SetupPage";
import Menus from "./menus.json";
import Menu from "../../components/Menu";
import EmployeeListPage from "../employee/list/EmployeeListPage";
import EmployeeFormPage from "../employee/form/EmployeeFormPage";
import UserListPage from "../user/list/UserListPage";
import JobListPage from "../job-posting/list/JobListPage";
import JobViewPage from "../job-posting/list/components/JobViewPage";
import ResignationListPage from "../Resignation/list/ResignationListPage";
import RequestListPage from "../request/list/RequestListPage";
import PositionTitlePage from "../job-posting/list/PositionTitlePage";
import OnlineApplicantListPage from "../listings/online-applicants/list/OnlineApplicantListPage";
import ApplicationFormPage from "../application-form/ApplicationFormPage";
import OnlineApplicantFormPage from "../listings/online-applicants/form/OnlineApplicantFormPage";
import MyOnlineApplicantListPage from "../my-listings/online-applicants/list/MyOnlineApplicantListPage";
import MyOnlineApplicantFormPage from "../my-listings/online-applicants/form/MyOnlineApplicantFormPage";
import WalkInApplicantListPage from "../listings/walkin-applicants/list/WalkInApplicantListPage";
import WalkInApplicantFormPage from "../listings/walkin-applicants/form/WalkInApplicantFormPage";
import MyWalkInApplicantFormPage from "../my-listings/walkin-applicants/form/MyWalkInApplicantFormPage";
import MyWalkInApplicantListPage from "../my-listings/walkin-applicants/list/MyWalkInApplicantListPage";
import ReprocessApplicantListPage from "../listings/re-process-applicants/list/ReprocessApplicantListPage";
import ReprocessApplicantFormPage from "../listings/re-process-applicants/form/ReprocessApplicantFormPage";
import MyReprocessApplicantListPage from "../my-listings/re-process-applicants/list/MyReprocessApplicantListPage";
import MyReprocessApplicantFormPage from "../my-listings/re-process-applicants/form/MyReprocessApplicantFormPage";
import InterviewFormPage from "../interview-form/walk-in-applicants/InterviewFormPage";
import InterviewOnlineFormPage from "../interview-form/online-applicants/InterviewOnlineFormPage";
import InterviewReprocessFormPage from "../interview-form/reprocess-applicants/InterviewReprocessFormPage";
import CalendarListPage from "../calendar/CalendarListPage";
import CalendarList from "../hrcalendar/CalendarListPage";
import CalendarListAdmin from "../admincalendar/CalendarListPage";
import InterviewListPage from "../coordinator-interview/list/InterviewListPage";
import InterviewCoordinatorFormPage from "../coordinator-interview/form/InterviewCoordinatorFormPage";
import OnBoardingListPage from "../on-boarding/list/OnBoardingListPage";
import ApplicantBoardingListPage from "../on-boarding/list/ApplicantBoardingListPage";
import MyCalendar from "../calendarPage/MyCalendar";
import CalendarCoordinatorPage from "../calendarcoordinator/CalendarCoordinatorPage";
import EmpResignationPage from "../empResignation/EmpResignationPage";
import EmpAccountPage from "../empAccount/EmpAccountPage";
import QrScanner from "../qr-scanner/QRScannerPage";
import QueueingViewPage from "../queueing/view/QueueingViewPage";
import QueueingListPage from "../queueing/list/QueueingListPage";
import LastPayListPage from "../last-pay/list/LastPayListPage";
import RecruiterCalendar from "../recruiterCalendarPage/RecruiterCalendar";
import RecruiterCalendarhr from "../hrrecruiterCalendarPage/RecruiterCalendar";
import AccountingCalendar from "../accountingCalendarPage/AccountingCalendar";
import ApplicantBoardingFormPage from "../on-boarding/form/ApplicantBoardingFormPage";
import OrientationFormPage from "../on-boarding/form/orientation-form/OrientationFormPage";
import ProductivityReportPage from "../hrAdminreports/recruitmentProd/ProductivityReport";
import EmployeeMasterPage from "../hrAdminreports/employeeMaster/EmployeeMasterPage";
import MyCalendarAdminPage from "../adminMyCalendar/MyCalendarAdminPage";
import MyCalendarHrPage from "../hrMyCalendar/MyCalendarHrPage";
import CalendarListPageHr from "../adminHrList/CalendarListPageHr";
import MyCalendarHr from "../adminSeeHrcalendarPage/MyCalendarHr";
import OthersListPage from "../queueing/list/others/OthersListPage";
import SurveyListPage from "../survey/list/SurveyListPage";
import SurveyFormPage from "../survey/form/SurveyFormPage";
import DashboardFormPage from "../dashboard-form/form/DashboardFormPage";
import AuditLogsListPage from "../audit-logs/AuditLogsListPage";
import ExitFormPage from "../exit-form/ExitFormPage";
import QueueingConfigPage from "../queueing/config/QueueingConfigPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
    );

    this.state = {
      userRoles: [],
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  filterAccess(menus, roles) {
    return menus?.filter((menu) => {
      if (Array.isArray(menu.route)) {
        menu.route = this.filterAccess(menu.route, roles);
      }
      if (!menu.access) {
        return true;
      }
      if (roles.some((role) => menu.access.includes(role?.id))) {
        return true;
      }
      return false;
    });
  }

  getUser() {}

  renderRoutes() {
    // const user = this.getCurrentUser();
    const { userRoles } = this.state;
    const accessDashboard = userRoles.some(
      (role) => role.id === "Admin" || role.id === "HR",
    );

    return (
      <>
        {accessDashboard && <Route path={"/"} element={<DashboardPage />} />}

        <Route path={"/collection/:name"} element={<CollectionListPage />} />
        <Route path={"/roles/form"} element={<RoleFormPage />} />
        <Route path={"/roles/form/:id"} element={<RoleFormPage />} />
        <Route
          path={"/collection/:name/form/"}
          element={<CollectionFormPage />}
        />
        <Route
          path={"/collection/:name/form/:id"}
          element={<CollectionFormPage />}
        />
        <Route path={"/migration"} element={<MigrationPage />} />
        <Route path={"/schema"} element={<SchemaPage />} />
        <Route path={"/account"} element={<AccountPage />} />
        <Route path={"/hooks"} element={<HooksPage />} />
        <Route path={"/function"} element={<FunctionPage />} />
        <Route path={"/setup"} element={<SetupPage />} />
        <Route path={"/admin/employees"} element={<EmployeeListPage />} />
        <Route path={"/admin/employee/form"} element={<EmployeeFormPage />} />
        <Route
          path={"/admin/employees/form/:id"}
          element={<EmployeeFormPage />}
        />
        <Route
          path={"/admin/employees/form/:name/:id"}
          element={<EmployeeFormPage />}
        />
        <Route path={"/admin/users"} element={<UserListPage />} />
        <Route path={"/admin/job-postings"} element={<JobListPage />} />
        <Route
          path={"/admin/job-postings/position-title"}
          element={<PositionTitlePage />}
        />
        <Route
          path={"admin/recruiter/calendar"}
          element={<CalendarListAdmin />}
        />
        <Route path={"/admin/HrCalendar"} element={<CalendarListPageHr />} />
        <Route path={"/admin/myCalendar"} element={<MyCalendarAdminPage />} />
        <Route path={"/admin/job-details/view/:id"} element={<JobViewPage />} />
        <Route path={"/all/resignation"} element={<ResignationListPage />} />
        <Route path={"/all/request"} element={<RequestListPage />} />
        <Route path={"/recruiter/calendar"} element={<CalendarListPage />} />
        <Route
          path={"/recruiter/online-applicants"}
          element={<OnlineApplicantListPage />}
        />
        <Route
          path={"/recruiter/online-applicant/form/:id"}
          element={<OnlineApplicantFormPage />}
        />
        <Route
          path={"/me/recruiter/online-applicants"}
          element={<MyOnlineApplicantListPage />}
        />
        <Route path={"/me/recruiter/calendar/:id"} element={<MyCalendar />} />
        <Route
          path={"/recruiter/Recruitercalendar/"}
          element={<RecruiterCalendar />}
        />
        <Route
          path={"/me/recruiter/online-applicant/form/:id"}
          element={<MyOnlineApplicantFormPage />}
        />
        <Route
          path={"/recruiter/walk-in-applicants"}
          element={<WalkInApplicantListPage />}
        />
        <Route
          path={"/recruiter/walkIn-applicant/form/:id"}
          element={<WalkInApplicantFormPage />}
        />
        <Route
          path={"/me/recruiter/walk-in-applicants"}
          element={<MyWalkInApplicantListPage />}
        />
        <Route
          path={"/me/recruiter/walkIn-applicant/form/:id"}
          element={<MyWalkInApplicantFormPage />}
        />
        <Route path={"/interview"} element={<InterviewFormPage />} />
        <Route
          path={"/recruiter/re-process"}
          element={<ReprocessApplicantListPage />}
        />
        <Route
          path={"/recruiter/re-process/form/:id"}
          element={<ReprocessApplicantFormPage />}
        />
        <Route
          path={"/me/recruiter/re-process"}
          element={<MyReprocessApplicantListPage />}
        />
        <Route
          path={"/me/recruiter/re-process/form/:id"}
          element={<MyReprocessApplicantFormPage />}
        />
        <Route
          path={"/interview/form/walkIn/:id"}
          element={<InterviewFormPage />}
        />
        <Route
          path={"/interview/form/online/:id"}
          element={<InterviewOnlineFormPage />}
        />
        <Route
          path={"/interview/form/reprocess/:id"}
          element={<InterviewReprocessFormPage />}
        />
        <Route
          path={"/interview/form/reprocess/:isPrevious/:id"}
          element={<InterviewReprocessFormPage />}
        />
        <Route
          path={"/coordinator/for-interview"}
          element={<InterviewListPage />}
        />
        <Route
          path={"/coordinator/for-interview/form/:type/:id/:recruiterId"}
          element={<InterviewCoordinatorFormPage />}
        />
        <Route
          path={"/recruiter/onboard-list/:id"}
          element={<ApplicantBoardingListPage />}
        />
        <Route path={"/onboarding"} element={<OnBoardingListPage />} />
        <Route
          path={"/onboarding/applicant/form/:status/:type/:id"}
          element={<ApplicantBoardingFormPage />}
        />
        <Route
          path={"/onboarding/applicant/orientation-form/:type/:id"}
          element={<OrientationFormPage />}
        />
        <Route
          path={"/coordinator/calendar"}
          element={<CalendarCoordinatorPage />}
        />
        <Route path={"/employee/profile"} element={<EmpAccountPage />} />
        <Route
          path={"/employee/resignation"}
          element={<EmpResignationPage />}
        />
        <Route path={"hr/recruiter/calendar"} element={<CalendarList />} />
        <Route
          path={"hr/recruiter/calendar/:id"}
          element={<RecruiterCalendarhr />}
        />
        <Route
          path={"/application-form/:type/:id"}
          element={<DashboardFormPage />}
        />
        <Route path={"/hr/myCalendar"} element={<MyCalendarHrPage />} />
        <Route path={"/hr/calendar/:id"} element={<MyCalendarHr />} />
        <Route path={"/qr-scanner"} element={<QrScanner />} />
        <Route path={"/queue"} element={<QueueingViewPage />} />
        <Route path={"/recruiter/queue"} element={<QueueingListPage />} />
        <Route path={"/others/queue/:type"} element={<OthersListPage />} />
        <Route path={"/queue/settings"} element={<QueueingConfigPage />} />

        <Route path={"/accounting/last_pay"} element={<LastPayListPage />} />
        <Route path={"/accounting/calendar"} element={<AccountingCalendar />} />
        <Route
          path={"/productivityReport"}
          element={<ProductivityReportPage />}
        />
        <Route path={"/list/survey"} element={<SurveyListPage />} />
        <Route path={"/survey/form/:id"} element={<SurveyFormPage />} />
        <Route path={"/EmployeeMasterList"} element={<EmployeeMasterPage />} />

        <Route path={"/audit-logs/:id"} element={<AuditLogsListPage />} />
        <Route path={"/exit-form"} element={<ExitFormPage />} />
        <Route path={"/exit-form/:id"} element={<ExitFormPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </>
    );
  }

  render() {
    const { pathname } = this.props.location;
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();
    const roles = this.getCurrentRoles();

    if (user === undefined || schemas === undefined) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Progress />
        </div>
      );
    }

    const showSidebar = pathname !== "/queue";
    const settings = [
      {
        name: "Edit Account",
        route: "/account",
        icon: "bi bi-person-check",
      },
      {
        name: "Schema",
        route: "/schema",
        icon: "bi bi-filetype-json",
      },
      // {
      //     name: "Notification",
      //     route: "/notification",
      //     icon: "bi bi-bell"
      // },
    ];

    const hook = [
      {
        name: "Hooks",
        route: "/hooks",
        icon: "bi bi-person-check",
      },
      {
        name: "Function",
        route: "/function",
        icon: "bi bi-person-check",
      },
    ];

    const setting = {
      name: "Settings",
      icon: "bi bi-sliders",
      route: settings,
    };

    const hooksMenu = {
      name: "WebHook",
      icon: "bi bi-sliders",
      route: hook,
    };
    return (
      <>
        {showSidebar ? (
          <Layout>
            <Layout.Context.Consumer>
              {(value) => (
                <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
                  <div
                    className="offcanvas-body"
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    <nav className="">
                      <div className="d-flex text-center">
                        <LogoHolder
                          className="bg-dark"
                          textClassName="text-white"
                          logo={user.picture}
                          name={user.username}
                          width={60}
                          height={60}
                        />
                        <p className="text-dark mt-3 ms-2">
                          {user.name || user.username}
                        </p>
                      </div>
                      <hr className=" bg-dark" />
                      <Menu
                        onClickItem={this.onClickMenu.bind(this)}
                        menus={this.filterAccess(Menus, roles)}
                      />
                    </nav>
                  </div>
                  <div className="p-3" style={{ backgroundColor: "#ffffff" }}>
                    <button
                      style={{ color: "#d82d2d" }}
                      className="nav-link btn btn-link"
                      onClick={this.onClickSignOut.bind(this)}
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span className="ms-2 fw-bold small">Log out</span>
                    </button>
                  </div>
                </OffCanvas>
              )}
            </Layout.Context.Consumer>
            <main className="vh-100 d-flex flex-column">
              <Routes>{this.renderRoutes()}</Routes>
            </main>
          </Layout>
        ) : (
          <Routes>{this.renderRoutes()}</Routes>
        )}
      </>
    );
  }
}

const MainPageWithLocation = (props) => {
  const location = useLocation();
  return <MainPage {...props} location={location} />;
};

export default withRouter(MainPageWithLocation);
